import carouselData from './carousel.settings'
import Navigation from './carousel.navigation'

const Flickity = require('flickity')

let extendedOptions = {}
const defaultOptions = carouselData.defaultOptions

window.addEventListener('load', () => {
	initializeCarousel()
})

const initializeCarousel = () => {
	const carousels = document.querySelectorAll(defaultOptions.carouselSelector)
	for ( let i=0, len = carousels.length; i < len; i++ ) {
		var currentCarousel = carousels[i];

		let customCarousel = Object.keys(carouselData);

		for (let property in customCarousel) {
			property = customCarousel[property]
			if (currentCarousel.classList.contains(property)) {
				extendedOptions = carouselData[property].extendedOptions
			}
		}

		const options = {...defaultOptions, ...extendedOptions}
		const carousel = new Flickity(currentCarousel, options)

		customFunctions(carousel, options)
	}
}

const customFunctions = (carousel, options) => {
	if (options.customNavigation) {
		const navigation = new Navigation(carousel, options)
		navigation.init()
    }
    if (options.draggable == null || options.draggable == true) {
        carouselDraggable()
    }
}

/* Carousel Util
   ========================================================================== */
const carouselDraggable = () => {
    let touchingCarousel = true;
    let touchStartCoords;
    document.body.addEventListener('touchstart', function (e) {
        touchStartCoords = {
            x: e.touches[0].pageX,
            y: e.touches[0].pageY,
        }
    });
    document.body.addEventListener('touchmove', function (e) {
        if (!(touchingCarousel && e.cancelable)) {
            return;
        }
        var moveVector = {
            x: e.touches[0].pageX - touchStartCoords.x,
            y: e.touches[0].pageY - touchStartCoords.y,
        };
        if (Math.abs(moveVector.x) > 7)
            e.preventDefault()
    }, {
        passive: false,
    });
}



// WEBPACK FOOTER //
// ./js/modules/carousel/carousel.default.js